import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { Field, FieldLabel } from "app/components/form/Field/Field";
import { CheckboxField } from "app/components/form/CheckboxField/CheckboxField";
import { useField } from "formik";

const PaymentTermsInput = ({
	cgvDocumentName,
	informationStandardForm,
	showInformationStandardForm,
	brandDisplayName,
	showPfsMessage,
}) => {
	const intl = useIntl();
	const [, meta] = useField("terms");

	return (
		<Field error={!!meta.error && meta.touched}>
			<CheckboxField
				name="terms"
				id="accept-terms"
				required
				data-testid="payment-terms-input"
				shouldValidate
			/>

			<FieldLabel htmlFor="accept-terms" required>
				<FormattedMessage
					values={{
						cgvLink: (
							<FormattedMessage id="general.cgv">
								{message => (
									<a
										className="relative-link"
										rel="noopener noreferrer"
										target="_blank"
										style={{ color: "inherit" }}
										href={cgvDocumentName}
									>
										{message}
									</a>
								)}
							</FormattedMessage>
						),
						secondaryLink: showInformationStandardForm && (
							<FormattedMessage id="payment.form.info.standard.link">
								{message => (
									<a
										className="relative-link"
										rel="noopener noreferrer"
										target="_blank"
										style={{ color: "inherit" }}
										href={informationStandardForm}
									>
										{message}
									</a>
								)}
							</FormattedMessage>
						),
						brandName: showPfsMessage
							? intl.formatMessage(
									{
										id: "general.perfectstay.partnership.name",
									},
									{ brandName: brandDisplayName }
								)
							: brandDisplayName,
						showPfsMessage,
					}}
					id="payment.terms.label"
				/>
			</FieldLabel>
		</Field>
	);
};

PaymentTermsInput.propTypes = {
	cgvDocumentName: PropTypes.string,
	informationStandardForm: PropTypes.string,
	showInformationStandardForm: PropTypes.bool,
	brandDisplayName: PropTypes.string,
	showPfsMessage: PropTypes.bool,
};

export default PaymentTermsInput;
